import { createAction, props } from '@ngrx/store';
import { MBanner } from '../models/banner';

export const GetBannerTile = createAction('[HOMEPAGE] Get banner tile');

export const GetBannerTileSuccess = createAction(
  '[HOMEPAGE] Get banner tile - success',
  props<{ banners: MBanner[]; bannersSize: string }>()
);

export const GetBannerTileError = createAction('[HOMEPAGE] Get banner tile - error', props<{ error: string }>());
